<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-10-10 14:43:39
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-21 18:21:23
-->
<template>
	<div>
		<template v-if="isBatch">
			<div class="flex-row-align-center">
				<span class="yx-color-text-primary yx-pingfang-Medium">确认合作商品</span>
				<span class="yx-color-text-primary font-h4-regular ml-12">已添加 {{ goodsTotal }}/10 (最多添加10个商品(SPU))</span>
			</div>
			<p class="mt-12 flex-row-align-center">
				<el-alert :closable="false" show-icon class="el-alert" title="商团协作样品订单必须选择sku，否则无法协同成功" type="warning"> </el-alert>
			</p>
		</template>
		<template v-else>
			<div class="yx-color-text-primary yx-pingfang-Medium">确认合作商品</div>
			<p class="mt-12 flex-row-align-center">
				<el-alert :closable="false" show-icon class="el-alert" title="商团协作样品订单必须选择sku，否则无法协同成功" type="warning"> </el-alert>
			</p>
		</template>
		<Tip class="mt-16 mb-16" v-if="includeNoSku">
			<p slot='content' class="font-h6-regular yx-color-text-primary">暂未获取到部分商品的规格，您可将申样要求填写在该商品对应的备注中</p>
		</Tip>
		<BaseTable :columns="columns" :list="goodsSpuList" :spanMethod="spanMethod" :options="options" class="mt-16 table-small"></BaseTable>
		<div class="pt-12 pr-16 pb-12 pl-16 font-h4-regular" v-if="isBatch">
			<el-button class="cursor-pointer" type="text" @click="addGoods" :disabled="goodsTotal >= goodsLimit">+ 添加商品</el-button>
			<span class="yx-color-text-secondary ml-4">({{ goodsTotal }}/{{ goodsLimit }})</span>
		</div>
		<div class="footer flex-row font-h6-regular yx-color-text-regular">
			<p class="yx-color-text-primary yx-color-text-regular flex-1">合计</p>
			<p style="width: 120px"></p>
			<p style="width: 200px"></p>
			<p style="width: 80px" class="yx-color-text-primary">{{ priceTotal | formatPrice }}</p>
			<p style="width: 120px">{{ skuTotal }}</p>
			<p style="width: 100px"></p>
			<p style="width: 80px" v-if="isBatch"></p>
		</div>
		<add-goods-drawer ref="addGoodsDrawer" @returnSelect="returnSelect" :platformId="platformId" :max-selected="10" />
		<addSkuDrawer ref="addSkuDrawer" @handleAddSku="handleAddSku" :platformId="platformId"></addSkuDrawer>
	</div>
</template>
<script>
import addGoodsDrawer from './components/addGoodsDrawer.vue';
import addSkuDrawer from '@/components/business/addSkuDrawer';
import columns, { operations } from './columns';
import { syncProductSkuList } from '@/api/shopManage';
export default {
	name: 'ConfirmCooGoods',
	components: {
		addGoodsDrawer,
		addSkuDrawer,
	},
	provide() {
		return {
			showSkuDrawer: this.showSkuDrawer,
			deleteSku: this.deleteSku,
			changeSkuNumbs: this.handleChange,
			changeSkuRamerk: this.handleRamerkChange,
		};
	},
	props: {
		isBatch: {
			type: Boolean,
			default: false,
		},
		chooseGoodsList: {
			type: Array,
			default: () => [],
		},
		platformId: {
			type: [Number, String],
			default: dataMap.PLATFORM_DY.value,
		},
	},
	watch: {
		chooseGoodsList: {
			handler(val) {
				let arr = JSON.parse(JSON.stringify(val));
				arr.forEach(item => {
					item.nums = 0;
					item.platform_id = this.platformId;
				});
				this.goodsSpuObj = arr.reduce((total, prev) => {
					!total[prev.productId] && (total[prev.productId] = [prev]);
					return total;
				}, {});
			},
			deep: true,
			immediate: true,
		},
	},
	computed: {
		thirdProductIdList({ selectGoods }) {
			let arr = selectGoods.map(item => item.thirdProductId);
			return [...new Set(arr)];
		},
		productIdList({ selectGoods }) {
			let arr = selectGoods.map(item => item.productId);
			return [...new Set(arr)];
		},
		goodsTotal({ goodsSpuObj }) {
			return Object.keys(goodsSpuObj).length;
		},
		skuTotal({ goodsSpuList }) {
			return goodsSpuList.reduce((pre, item) => pre + item.nums, 0);
		},
		priceTotal({ goodsSpuList }) {
			return goodsSpuList.reduce((total, item) => total + Number(item.price) * item.nums, 0).toFixed(2);
		},
		isDisableDel({ goodsSpuObj }) {
			return Object.keys(goodsSpuObj).length <= 1;
		},
		// 商品spu列表，用于渲染商品列表
		goodsSpuList() {
			return this.calculateSpan(this.goodsSpuObj);
		},
		includeNoSku({ chooseGoodsList }) {
			 return chooseGoodsList.filter(item => !item.skuId).length;
		},
	},
	data() {
		return {
			selectGoods: [],
			goodsSpuObj: [],
			columns: [],
			options: {
				border: true,
			},
			// 最多只能选中的商品spu个数
			goodsLimit: 10,
		};
	},
	created() {
		// 批量申样才会有删除商品操作
		this.columns = this.isBatch ? [...columns, operations] : columns;
	},
	methods: {
		addGoods() {
			this.$refs.addGoodsDrawer.show(this.goodsSpuObj);
		},
		returnSelect(val) {
			const selectedObj = val.reduce((total, prev) => {
				prev.platform_id = this.platformId;
				total[prev.productId] = [prev];
				return total;
			}, {});
			this.goodsSpuObj = { ...this.goodsSpuObj, ...selectedObj };
			this.asyncSkuList(val);
		},
		async asyncSkuList(list) {
			// 同步商品sku， 抖音更改了同步sku的限额，所以只能按需同步，使用哪个商品就调用同步哪个sku
			const productIds = list.map(item => ({
				outProductId: item.thirdProductId,
				productId: item.productId,
			}));
			await syncProductSkuList({
				platformId: this.platformId,
				productIds,
				source: dataMap.syncSkuSource.apply_sample,
			});
		},
		getSelectList() {
			return this.goodsSpuObj;
		},
		reset() {
			this.goodsSpuObj = [];
			this.selectGoods = [];
		},
		delGoods(productId) {
			const _obj = { ...this.goodsSpuObj };
			delete _obj[productId];
			this.goodsSpuObj = _obj;
		},
		handleChange(val, { id, productId }) {
			this.goodsSpuObj[productId].find(item => item.id === id).nums = val;
			this.goodsSpuObj = { ...this.goodsSpuObj };
		},
		handleRamerkChange(val, { id, productId }) {
			this.goodsSpuObj[productId].find(item => item.id === id).specificationRemark = val;
			this.goodsSpuObj = { ...this.goodsSpuObj };
		},
		showSkuDrawer(productId) {
			// 展示添加sku抽屉
			this.$refs.addSkuDrawer.show(
				productId,
				this.goodsSpuObj[productId].filter(item => item.choosed),
			);
		},
		handleAddSku(selectedGoodsSkus) {
			// 获取sku对应的spu商品ID
			const { productId } = selectedGoodsSkus[0];
			// 将选中的sku添加到spu下的sku列表中，并设置sku为选中状态（为了与初始的spu数据作区分）,并且设置申样数量为1
			const hasSku = this.goodsSpuObj[productId].some(item => item.choosed);
			const formatdSku = selectedGoodsSkus.map(item => ({ ...item, choosed: true, nums: 1, hasSku: true }));
			if (hasSku) {
				this.goodsSpuObj[productId].push(...formatdSku);
			} else {
				this.goodsSpuObj[productId] = formatdSku;
			}
			// 触发计算属性goodsSpuList重新计算
			this.goodsSpuObj = { ...this.goodsSpuObj };
		},
		deleteSku(productId, skuId) {
			const isOnlyOne = this.goodsSpuObj[productId].length === 1;
			// 如果只剩最后一个sku，那么就只把sku的choosed字段删除，会触发calculateSpan方法里重新设置为spu样式展示
			// 不止一个就将spu的sku列表中找到id相同的sku进行删除
			if (isOnlyOne) {
				delete this.goodsSpuObj[productId][0]['choosed'];
			} else {
				const index = this.goodsSpuObj[productId].findIndex(item => item.id === skuId);
				this.goodsSpuObj[productId].splice(index, 1);
			}
			// 触发计算属性goodsSpuList重新计算
			this.goodsSpuObj = { ...this.goodsSpuObj };
		},
		// 合并单元格方法
		spanMethod({ row: { rowspan, colspan }, column, rowIndex, columnIndex }) {
			// 商品信息、选择寄样规格、操作列进行合并单元格处理
			if ([0, 1, 5, 6].includes(columnIndex)) {
				return {
					rowspan,
					colspan,
				};
			}
		},
		getButtons() {
			return [
				{
					label: '删除',
					type: 'text',
					disabled: this.isDisableDel,
					click: row => this.delGoods(row.productId),
				},
			];
		},
		calculateSpan(obj) {
			const _list = [];
			Object.keys(obj).forEach(productId => {
				let __list = [];
				const choosed = obj[productId].filter(item => item.choosed);
				if (!choosed.length) {
					__list = [{ ...obj[productId][0], specification: '', nums: 0, operations: this.getButtons(), rowspan: 1, colspan: 1 }];
				} else {
					__list = [
						...choosed.map((item, index) => {
							// 删除按钮需要重新渲染，存在逻辑为只有一个spu时删除按钮禁用
							item.operations = this.getButtons();
							if (!item.platform_id) {
								item.platform_id = this.platformId;
							}
							if (index === 0) {
								item.rowspan = choosed.length;
								item.colspan = 1;
							} else {
								item.rowspan = 0;
								item.colspan = 0;
							}
							return { ...item };
						}),
					];
				}
				_list.push(...__list);
			});
			return _list;
		},
	},
};
</script>
<style lang="less" scoped>
.footer {
	padding: 14px 0px;
	background-color: #f7f8fa;
	border-radius: 2px;
	p {
		padding: 0px 16px;
		box-sizing: border-box;
	}
}
/deep/.el-tag--plain.el-tag--info {
	border-color: #e1e3e8 !important;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
	background-color: #ffffff;
}
/deep/.el-table--enable-row-transition .el-table__body td.el-table__cell {
	&:nth-child(1),
	&:nth-child(2),
	&:nth-child(6) {
		vertical-align: middle;
	}
}
.el-alert {
	/deep/ .el-alert__title {
		color: @color-black;
		font-size: 12px;
	}
}
/deep/.table-btns {
	height: 65px;
}
</style>
